import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNoFiles = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 210,
	height: 120,
	viewBox: "0 0 210 120",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M124.689 100.509L74.1349 109.754C73.39 109.89 72.6215 109.724 71.9985 109.294C71.3755 108.864 70.9489 108.203 70.8127 107.459L59.5136 45.6701C59.3774 44.9253 59.5426 44.1568 59.973 43.5338C60.4034 42.9107 61.0637 42.4842 61.8086 42.348L95.5113 36.1848L118.766 52.2496L126.984 97.1867C127.12 97.9315 126.955 98.7 126.525 99.323C126.094 99.9461 125.434 100.373 124.689 100.509Z",
			fill: "#FBFBFB",
			stroke: "#D4D4D4",
			strokeWidth: 2.10841,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M131.134 103.397H79.7419C78.9846 103.397 78.2584 103.096 77.723 102.561C77.1875 102.026 76.8867 101.299 76.8867 100.542V37.729C76.8867 36.9718 77.1875 36.2456 77.723 35.7102C78.2584 35.1747 78.9846 34.8739 79.7419 34.8739H114.004L133.99 54.8599V100.542C133.99 101.299 133.689 102.026 133.153 102.561C132.618 103.096 131.892 103.397 131.134 103.397Z",
			fill: "#FBFBFB",
			stroke: "#D4D4D4",
			strokeWidth: 2.10841,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M112.576 34.8739V56.2874H133.99",
			stroke: "#D4D4D4",
			strokeWidth: 2.10841,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M119 26.3768C125.5 28.7101 140.4 31.9768 148 26.3768C155.6 20.7768 158 13.8768 154.5 8.87676C152.667 6.87676 147.16 3.55102 142.5 8.87676C139 12.8767 140 18.1076 144.5 20.8768C151 24.8768 164.4 23.6767 174 8.87676",
			stroke: "#E0E0E0",
			strokeWidth: 3,
			strokeLinecap: "round"
		})
	]
});
export default SvgNoFiles;
